(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gsus4-payment-options"] && !Shopify.designMode) return;
  try {
    (function () {
    function readPaymentData(root) {
      if (root.gsus4PaymentData) {
        return root.gsus4PaymentData;
      }

      var dataElement = root.querySelector(
        '[data-gsus4-payment-data]'
      );

      if (!dataElement) {
        return null;
      }

      try {
        root.gsus4PaymentData = JSON.parse(
          dataElement.textContent
        );

        return root.gsus4PaymentData;
      } catch (error) {
        return null;
      }
    }

    function getProductMain(root) {
      return (
        root.closest('.product-main') ||
        document
      );
    }

    function getVariantIdFromEvent(event) {
      var detail = event && event.detail;

      if (!detail) {
        return '';
      }

      if (
        detail.variant &&
        detail.variant.id
      ) {
        return String(detail.variant.id);
      }

      if (detail.variantId) {
        return String(detail.variantId);
      }

      if (detail.id) {
        return String(detail.id);
      }

      return '';
    }

    function findSelectedVariantId(
      root,
      event
    ) {
      var eventVariantId =
        getVariantIdFromEvent(event);

      if (eventVariantId) {
        return eventVariantId;
      }

      var productMain =
        getProductMain(root);

      var form =
        productMain.querySelector(
          'form[action*="/cart/add"]'
        );

      if (form) {
        var checkedInput =
          form.querySelector(
            'input[name="id"]:checked'
          );

        if (
          checkedInput &&
          checkedInput.value
        ) {
          return String(
            checkedInput.value
          );
        }

        var select =
          form.querySelector(
            'select[name="id"]'
          );

        if (
          select &&
          select.value
        ) {
          return String(select.value);
        }

        var variantInput =
          form.querySelector(
            'input[name="id"]'
          );

        if (
          variantInput &&
          variantInput.value
        ) {
          return String(
            variantInput.value
          );
        }
      }

      var data = readPaymentData(root);

      return data
        ? String(data.selectedVariantId)
        : '';
    }

    function updateQuarterPayment(
      root,
      event
    ) {
      var data = readPaymentData(root);

      if (!data) {
        return;
      }

      var variantId =
        findSelectedVariantId(
          root,
          event
        );

      var fallbackId =
        String(data.selectedVariantId);

      var price;

      if (
        Object.prototype.hasOwnProperty.call(
          data.variants,
          variantId
        )
      ) {
        price =
          data.variants[variantId];

        data.selectedVariantId =
          variantId;
      } else {
        price =
          data.variants[fallbackId];
      }

      if (typeof price !== 'number') {
        return;
      }

      var amount =
        new Intl.NumberFormat(
          document.documentElement.lang ||
            'en-AU',
          {
            style: 'currency',
            currency: data.currency
          }
        ).format(price / 400);

      root
        .querySelectorAll(
          '[data-gsus4-quarter-payment]'
        )
        .forEach(function (element) {
          element.textContent = amount;
        });
    }

    function compactStudio19(root) {
      var portal =
        root.querySelector(
          '.s19-detail-portal'
        );

      if (!portal) {
        return;
      }

      var amountElement =
        portal.querySelector(
          '.s19-price-amount'
        );

      var periodElement =
        portal.querySelector(
          '.s19-per-period'
        );

      if (
        !amountElement ||
        !periodElement
      ) {
        return;
      }

      var amount =
        amountElement.textContent.trim();

      var period =
        periodElement.textContent.trim();

      var compactPeriod =
        period
          .replace(/^per\s+/i, '/')
          .replace(/\s+/g, '-');

      var rate =
        amount +
        compactPeriod;

      var label =
        'Studio19 ' +
        rate;

      portal.setAttribute(
        'data-gsus4-studio19-rate',
        rate
      );

      portal.setAttribute(
        'data-gsus4-studio19-label',
        label
      );

      portal.setAttribute(
        'aria-label',
        label
      );
    }

    function getStudio19ApplicationLink(
      root
    ) {
      var productMain =
        getProductMain(root);

      return (
        productMain.querySelector(
          '.s19-component a[href*="/rentnow/"]'
        ) ||
        document.querySelector(
          '.s19-component a[href*="/rentnow/"]'
        )
      );
    }

    function getStudio19ApplicationUrl(
      root
    ) {
      var applicationLink =
        getStudio19ApplicationLink(root);

      if (applicationLink) {
        return applicationLink.href;
      }

      var variantId =
        findSelectedVariantId(root);

      var studioVariant =
        window.initialVariantData &&
        window.initialVariantData[
          String(variantId)
        ];

      if (
        !studioVariant ||
        !studioVariant.id
      ) {
        return '';
      }

      return (
        'https://secure.studio19.com.au/rentnow/gsus4/' +
        encodeURIComponent(
          studioVariant.id
        ) +
        '/'
      );
    }

    function initializePaymentOptions(
      root
    ) {
      if (
        root.dataset
          .gsus4PaymentReady === 'true'
      ) {
        return;
      }

      root.dataset.gsus4PaymentReady =
        'true';

      var studioSlot =
        root.querySelector(
          '[data-gsus4-studio19-slot]'
        );

      if (studioSlot) {
        new MutationObserver(
          function () {
            compactStudio19(root);
          }
        ).observe(studioSlot, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      compactStudio19(root);
      updateQuarterPayment(root);
    }

    function initializeAll(scope) {
      scope
        .querySelectorAll(
          '[data-gsus4-payment-options]'
        )
        .forEach(
          initializePaymentOptions
        );
    }

    function updatePaymentOptionsForForm(
      form,
      event
    ) {
      var productMain =
        form.closest('.product-main') ||
        document;

      productMain
        .querySelectorAll(
          '[data-gsus4-payment-options]'
        )
        .forEach(function (root) {
          updateQuarterPayment(
            root,
            event
          );
        });
    }

    document.addEventListener(
      'click',
      function (event) {
        if (
          !(
            event.target instanceof
            Element
          )
        ) {
          return;
        }

        var studioTrigger =
          event.target.closest(
            '[data-gsus4-studio19-slot] .s19-detail-portal'
          );

        if (!studioTrigger) {
          return;
        }

        var root =
          studioTrigger.closest(
            '[data-gsus4-payment-options]'
          );

        if (!root) {
          return;
        }

        var applicationLink =
          getStudio19ApplicationLink(
            root
          );

        var applicationUrl =
          getStudio19ApplicationUrl(
            root
          );

        if (!applicationUrl) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (applicationLink) {
          applicationLink.click();
          return;
        }

        var applicationWindow =
          window.open(
            applicationUrl,
            '_blank',
            'noopener,noreferrer'
          );

        if (applicationWindow) {
          applicationWindow.opener =
            null;
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        if (
          !(
            event.target instanceof
            Element
          )
        ) {
          return;
        }

        var trigger =
          event.target.closest(
            '[data-gsus4-payment-trigger]'
          );

        if (trigger) {
          var root =
            trigger.closest(
              '[data-gsus4-payment-options]'
            );

          var dialog =
            root &&
            root.querySelector(
              '[data-gsus4-payment-dialog]'
            );

          var provider =
            trigger.getAttribute(
              'data-gsus4-payment-trigger'
            );

          if (!dialog) {
            return;
          }

          root.gsus4PaymentTrigger =
            trigger;

          dialog
            .querySelectorAll(
              '[data-gsus4-payment-panel]'
            )
            .forEach(
              function (panel) {
                panel.hidden =
                  panel.getAttribute(
                    'data-gsus4-payment-panel'
                  ) !== provider;
              }
            );

          if (!dialog.open) {
            dialog.showModal();
          }

          return;
        }

        var closeButton =
          event.target.closest(
            '[data-gsus4-payment-close]'
          );

        if (closeButton) {
          closeButton
            .closest('dialog')
            .close();

          return;
        }

        if (
          event.target.matches(
            '[data-gsus4-payment-dialog]'
          )
        ) {
          event.target.close();
        }
      }
    );

    document.addEventListener(
      'change',
      function (event) {
        if (
          !(
            event.target instanceof
            Element
          )
        ) {
          return;
        }

        var form =
          event.target.closest(
            'form[action*="/cart/add"]'
          );

        if (!form) {
          return;
        }

        window.requestAnimationFrame(
          function () {
            updatePaymentOptionsForForm(
              form,
              event
            );
          }
        );
      }
    );

    [
      'variant:change',
      'product:variant-change'
    ].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function (event) {
          var target =
            event.target instanceof
            Element
              ? event.target
              : document;

          var productMain =
            target.closest &&
            target.closest(
              '.product-main'
            );

          var scope =
            productMain || document;

          scope
            .querySelectorAll(
              '[data-gsus4-payment-options]'
            )
            .forEach(
              function (root) {
                updateQuarterPayment(
                  root,
                  event
                );
              }
            );
        }
      );
    });

    document.addEventListener(
      'close',
      function (event) {
        if (
          !(
            event.target instanceof
            Element
          )
        ) {
          return;
        }

        if (
          !event.target.matches(
            '[data-gsus4-payment-dialog]'
          )
        ) {
          return;
        }

        var root =
          event.target.closest(
            '[data-gsus4-payment-options]'
          );

        if (
          root &&
          root.gsus4PaymentTrigger
        ) {
          root.gsus4PaymentTrigger.focus();
        }
      },
      true
    );

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          initializeAll(document);
        },
        {
          once: true
        }
      );
    } else {
      initializeAll(document);
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        initializeAll(event.target);
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
